import React from 'react';

export const CrowdSourceIcon = ({ style = {}, width = '100%', className = '', viewBox = '0 0 36 36' }) => (
  <svg
    stroke="currentColor"
    fill="none"
    stroke-width="2"
    viewBox="0 0 24 24"
    stroke-linecap="round"
    stroke-linejoin="round"
    height="1em"
    width="1.5em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(-6 0)">
      <circle cx="11.5" cy="11.5" r="10" />
      <circle cx="24.5" cy="11.5" r="10" />
    </g>
  </svg>
);
